import styled from "styled-components"

const ToggleWrapper = styled.div`
  .react-toggle .react-toggle-track,
  .react-toggle:hover:not(.react-toggle--disabled) .react-toggle-track {
    background-color: ${({theme}) => theme.colors.greys.mediumLight};
  }
  .react-toggle--checked .react-toggle-track,
  .react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {
    background-color: ${({theme}) => theme.colors.success};
  }
`

export default ToggleWrapper
